var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import styles from './index.css';
import auth from '../../../../base/auth';
import FaceList from './faceList';
import { postComment } from '../../utils/api';
// @flow
class CommentInput extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            value: '',
            faceListShow: false,
        };
        // 提交评论
        this.postContent = (content) => __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield postComment(content, this.props.articleInfo);
                if (data.code) {
                    this.setState({
                        value: '',
                    });
                    window.alert('发表成功！');
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        // 提交评论内容
        this.handleSubmit = () => {
            // 已经登录，且已经实名，则可以发表评论
            if (auth.isReal()) {
                const content = this.state.value;
                if (content === '') {
                    window.alert('请填写评论内容！');
                }
                else if (content.length > this.props.articleInfo.cmtLength) {
                    window.alert('评论内容过长，超过最大限制1000个字符！');
                }
                else {
                    this.postContent(content);
                }
            }
            else {
                if (auth.isLogin()) {
                    window.alert('您还没有实名认证，请先进行实名认证');
                }
                window.alert('您还没有登录，请先登录');
                window.location.href = `//user.ifeng.com/login?cb=${location.href}`;
            }
        };
        this.handleChange = (e) => {
            const value = (e.currentTarget && e.currentTarget.value) || '';
            this.setState({
                value,
            });
        };
        this.handleInput = (val) => {
            const { value } = this.state;
            this.setState({
                value: `${value}${val}`,
            });
        };
        this.handleFaceListShow = () => {
            const { faceListShow } = this.state;
            this.setState({
                faceListShow: !faceListShow,
            });
        };
    }
    render() {
        const { value, faceListShow } = this.state;
        return (React.createElement("div", { className: styles.ipt },
            React.createElement("textarea", { placeholder: "\u5199\u8BC4\u8BBA", value: value, onChange: this.handleChange.bind(this) }),
            React.createElement("div", { className: styles.bar },
                React.createElement("span", { onClick: this.handleFaceListShow }),
                React.createElement("a", { onClick: this.handleSubmit }, "\u53D1\u8868\u8BC4\u8BBA")),
            faceListShow ? (React.createElement(FaceList, { handleFaceListShow: this.handleFaceListShow, handleInput: this.handleInput })) : ('')));
    }
}
export default CommentInput;
